import HttpService from './HttpService';
import AuthService from "@/services/AuthService";
export default class InsurancePricingService {
  constructor() {
    this._httpService = new HttpService();
    this._authService = new AuthService();
  }

  async getRequestData(model) {
    
    let response = await this._authService.findUserCurrent();
    let addfields = response.data.principal.user.additionalFields;

    let modelId = addfields.filter(
      (a) =>
        (a.key == 'modelId'),
    );
    
    let request = {
      type: model.type,
      accommodation: this.getaccommodation(model),
      companyLives: this.getTabelaBeneficiarios(model),
      copay: this.getcooparticipacao(model),
      personLives: this.getPersonLives(model),
      userId: response.data.principal.user.id,
      cityId: model.region.Id,
      leadId:  modelId.length>0 ? modelId[0].value : null,
      opportunityId: this.nullIfEmpty(addfields && addfields.opportunityId),
      accountId: this.nullIfEmpty(addfields && addfields.accountId),
      quoteOriginId: this.nullIfEmpty(addfields && addfields.quoteId),
      quoteUser: !model.simulate ? this.getQuoteUser(model) : null,
      studyConfigurationId: model.selectProjeto.id,
      origin: model.origin.replace("origin="),
      selectedQuotes: model.simulate ? null : this.getSelectedPlanos(model)
    };
    console.log(request);
    return request;
  }

  nullIfEmpty(val) {
    if (val && val.length > 0) return val;
    return null;
  }

  getRequestModel(request) {
    let model = {
      loadquote: true,
      exibirSalesforce: false,
      user: request.quoteUser,
      origin: request.origin,
      type: request.type,
      quoteOriginDate: request.quoteOriginDate,
      persontype: (request.companyLives && !request.personLives) ? "PJ" : "PF",
      selectProjeto: this.getStudyConfigurationModel(request),
      cooparticipacao: this.getcooparticipacaoModel(request),
      accommodation: this.getaccommodationModel(request),
      region: this.getRegionModel(request),
      planosload: this.getPlanosModel(request),
      planos: [],
      beneficiarios: this.getbeneficiariosModel(request)
    };
    //model.user.userId = request.userId;
    return model;
  }

  getStudyConfigurationModel(request) {
    return {
      Id: request.studyConfigurationId
    }
  }
  getRegionModel(request) {
    return {
      Id: request.cityId
    }
  }
  getPlanosModel(request) {
    let retorno = [];
    for (let index = 0; index < request.selectedQuotes.length; index++) {
      retorno.push({
        productId: request.selectedQuotes[index].productId
      })
    }
    return retorno;
  }
  getaccommodationModel(request) {
    let retorno = [];
    retorno.push({ label: 'Enfermaria', check: (request.accommodation === "BOTH" || request.accommodation === "NURSERY") });
    retorno.push({ label: 'Apartamento', check: (request.accommodation === "BOTH" || request.accommodation === "APARTMENT") });
    return retorno.filter(f => f.check);
  }
  getcooparticipacaoModel(request) {
    let retorno = [];
    retorno.push({ label: 'Sem Coparticipação', check: (request.copay === "BOTH" || request.copay === "WITHOUT_COPAY") });
    retorno.push({ label: 'Com Coparticipação', check: (request.copay === "BOTH" || request.copay === "WITH_COPAY") });
    return retorno.filter(f => f.check);
  }
  getbeneficiariosModel(request) {
    if (request.personLives) {
      let retorno = [];
      request.personLives.forEach(pl => {
        retorno.push({
          tipo: this.getPersonTypeModel(pl.type),
          idade: pl.age.toString(),
        })
      });

      return retorno;
    }
    else if (request.companyLives) {
      let retorno = this.getTabelaBeneficiariosPJ();

      // varrendo tabela selecionada
      request.companyLives.forEach(company => {
        // varredando tabela
        retorno.forEach(tabela => {
          let _com = company.ageRange
            .replace("FROM_", "")
            .replace("_TO_", "-")
            .replace("_PLUS", "+")
            .trim();

          if (_com == tabela.descricao) {
            tabela.d = company.dependentCount.toString();
            tabela.t = company.holderCount.toString();
            tabela.a = company.othersCount.toString();
          }
        });
      });

      return retorno;
    }
    else {
      return null;
    }
  }
  getPersonTypeModel(tipo) {
    switch (tipo.toUpperCase()) {
      case "HOLDER":
        return "Titular";
      case "DEPENDENT":
        return "Dependente";
      default:
        return "Agregado";
    }
  }

  getaccommodation(model) {
    let retorno = "BOTH";
    if (model.accommodation) {
      if (model.accommodation.length == 1)
        return model.accommodation[0].label.toUpperCase().includes("APART") ? "APARTMENT" : "NURSERY";
    }

    return retorno;
  }
  getcooparticipacao(model) {
    let retorno = "BOTH";
    if (model.cooparticipacao) {
      if (model.cooparticipacao.length == 1) {
        return model.cooparticipacao[0].label.toUpperCase().includes("COM") ? "WITH_COPAY" : "WITHOUT_COPAY";
      }
    }
    return retorno;
  }
  getTabelaBeneficiarios(model) {
    if (model.persontype == "PJ") {
      let tabela = [];
      model.beneficiarios.forEach(ben => {
        if (ben.t > 0 || ben.d > 0 || ben.a > 0)
          tabela.push({
            ageRange: `FROM_${ben.min}_${(ben.min >= 59 ? 'PLUS' : ('TO_' + ben.max))}`,
            dependentCount: parseInt(ben.d ? ben.d : 0),
            holderCount: parseInt(ben.t ? ben.t : 0),
            othersCount: parseInt(ben.a ? ben.a : 0),
          })
      });
      return tabela;
    }
    return null;
  }
  getPersonLives(model) {
    if (model.persontype == "PF") {
      let rq = [];
      model.beneficiarios.forEach(ben => {
        rq.push({
          age: ben.idade,
          type: this.getPersonType(ben.tipo)
        })
      });
      return rq;
    }
    return null;
  }
  getPersonType(tipo) {
    switch (tipo.toUpperCase()) {
      case "TITULAR":
        return "HOLDER";
      case "DEPENDENTE":
        return "DEPENDENT";
      default:
        return "OTHERS";
    }
  }
  getQuoteUser(model) {
    model.user.userId = null;
    return model.user;
  }
  getSelectedPlanos(model) {
    var planoIds = [];
    model.planos.forEach(p => planoIds.push({
      productId: p.productId
    }))
    return planoIds;
  }

  async LoadQuote(quoteId) {
    return await this._httpService.get('/api/salesforce/insurance_pricing/load_quote', { quoteId });
  }

  async Quote(model) {
    let data = await this.getRequestData(model);
    return await this._httpService.post('/api/insurance_pricing/pricing/quote', data);
  }

  async Simulate(model) {
    let data = await this.getRequestData(model);
    return await this._httpService.post('/api/insurance_pricing/pricing/simulate', data);
  }

  async getQuotePrice(data) {
    let cotacoes = [];
    var listcot = data.QuoteLineItems ? data.QuoteLineItems : data.quoteLineItems;
    listcot.forEach(quote => {
      console.log(quote)
      var carrier = quote.product_id.plan_family_id.carrier_id;

      if (cotacoes.some(s => s.seguradoracodigo == carrier.id)) {
        var seg = cotacoes.filter(s => s.seguradoracodigo == carrier.id)[0];

        // add plano
        var plan = this.getplan(quote);

        // agrupar planos com cooparticipação
        if (seg.planos.some(s => s.nome == plan.nome)) {
          // buscar plano
          var bExistPlano = seg.planos.filter(s => s.nome == plan.nome)[0];

          // concatenar
          bExistPlano.coparticipacao2 = plan.coparticipacao;
          bExistPlano.preco2 = plan.preco;
        }
        else {
          seg.planos.push(plan);

          //add preço
          seg.precos.push(this.getprice(quote));

          // sort
          seg.planos = seg.planos.sort(function (a, b) {
            return a.preco <= b.preco ? -1 : a.preco > b.preco ? 1 : 0;
          });
          // set menor preço
          seg.menorPreco = seg.planos && seg.planos.filter(x => x.preco > 0)[0].preco
        }
        seg;
      }
      else {
        cotacoes.push(this.getInsurance(carrier, quote));
      } // fim else
    });
    cotacoes.forEach(c => c.planos.sort((v1, v2) => v2.priority - v1.priority));
    return cotacoes;
  }

  getplan(quote) {
    var retorno = {
      seguradoracodigo: quote.product_id.plan_family_id.carrier_id.id,
      seguradora: quote.product_id.plan_family_id.carrier_id.name,
      coparticipacao: quote.x_studio_copay == "WITH_COPAY" ? "Com Coparticipação" : "Sem Coparticipação",
      acomodacao: quote.product_id.accommodation_id, //== "enf" ? "Enfermaria" : "Apartamento",
      segmentacao: quote.product_id.segmentation_id,
      nome: quote.product_id.name,
      productId: quote.product_id.id,
      productFamilyId: quote.product_id.plan_family_id.id,
      quoteId: quote.id,
      priority: quote.product_id.priority,
      preco: quote.price_unit,
      regiao: quote.x_studio_accredited_network.region_id.name,
      check: false
    }

    return retorno;
  }
  getprice(quote) {
    return {
      priceId: quote.id,
      productId: quote.product_id.id,
      familyId: quote.product_id.plan_family_id.id,
      carrierId: quote.product_id.plan_family_id.carrier_id.id,
      preco: quote.price_unit,
      check: false
    }
  }
  getInsurance(carrier, quote) {
    return {
      seguradoracodigo: carrier.id,
      nome: carrier.name.toUpperCase(),
      img: carrier.image_1920,
      menorPreco: quote.price_unit,
      precos: [this.getprice(quote)], // fim preços
      planos: [this.getplan(quote)]// fim planos
    }
  }

  async getProjetos(userId, cityId, personType) {
    return await this._httpService.post('/api/insurance_pricing/pricing/study_configurations/', { cityId, personType, userId });
  }

  async getCooparticipacao(cityId, studyConfigurationId) {
    return await this._httpService.post('/api/insurance_pricing/pricing/copays', { cityId, studyConfigurationId }).then(res => {
      var copys = res.data.map(m => ({
        label: m.label.replace("COM COPARTICIPAÇÃO", "Com Coparticipação").replace("SEM COPARTICIPAÇÃO", "Sem Coparticipação"),
        value: m.value
      }));
      return { data: [...copys] }
    });
  }

  async getAcomodacoes(cityId, studyConfigurationId) {
    return await this._httpService.post('/api/insurance_pricing/pricing/accomodations', { cityId, studyConfigurationId });
  }

  getTabelaBeneficiariosPJ() {
    return [
      {
        descricao: "0-18",
        min: 0,
        max: 18,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "19-23",
        min: 19,
        max: 23,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "24-28",
        min: 24,
        max: 28,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "29-33",
        min: 29,
        max: 33,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "34-38",
        min: 34,
        max: 38,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "39-43",
        min: 39,
        max: 43,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "44-48",
        min: 44,
        max: 48,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "49-53",
        min: 49,
        max: 53,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "54-58",
        min: 54,
        max: 58,
        t: "",
        d: "",
        a: "",
      },
      {
        descricao: "59+",
        min: 59,
        max: 999,
        t: "",
        d: "",
        a: "",
      },
    ]

  }
}
